import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgSelectModule } from '@ng-select/ng-select'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../guards/user-permissions.guard'
import { MaterialModule } from '../../../shared/material.module'
import { SharedModule } from '../../../shared/shared.module'
import { CreateRebateClaimComponent } from './create-rebate-claim.component'

@NgModule({
  declarations: [CreateRebateClaimComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    SharedModule,
    MaterialModule,
    SpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        CreateRebateClaimComponent: {
          component: CreateRebateClaimComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class CreateRebateClaimModule {}
